// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global variables adn mixins are defined here */
::ng-deep .cdk-global-scrollblock {
  overflow: hidden;
}

::ng-deep mat-pseudo-checkbox {
  width: 0px !important;
}

::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  width: auto !important;
}

::ng-deep .mdc-list-item__primary-text {
  margin: 0px !important;
}

::ng-deep .mdc-tab__ripple {
  display: none;
}

::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled ~ .mdc-checkbox__background {
  background-color: #3e97ff !important;
  border-color: #3e97ff !important;
}

.toaster {
  background-color: #f4f7ff !important;
}

/* variables */
/* MIXINS */
/* mixin for border radius */
/* To create a section at the center of window */
/* To include and adjust background image */
/* to split the input */
/* box-shadow generator
    \$clr- in RGBA format
 */
/*
remove the autofilled background color
*/
/* mixin for create buttons */
/* generate margin & padding */
/* to set the table row */
/* to set the image */
/* to set the styles for first and last child div */
/* to set the font style */
.ast-table .table {
  margin-bottom: 0px;
}
.ast-table table thead th {
  background-color: #edeced;
  border: 1px solid #dee2e6;
  border-top: none !important;
}
.ast-table table td {
  background-color: #fafafa;
  color: #231f20;
  border: 0.5px solid #e2e2e1;
  font-size: 16px;
  font-weight: 500;
  font-family: "Amazon Ember Display Light";
}

/* To create a card at the center */
::ng-deep mat-pseudo-checkbox {
  display: none !important;
}

::ng-deep .mat-calendar-body-selected {
  background-color: #3e97ff !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {
  border-bottom: none !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before {
  border-bottom: none !important;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  background-color: #f2f4ff !important;
}

::ng-deep .mat-form-field {
  border: none !important;
}

.dateselect mat-form-field {
  display: flex;
  height: 25px;
  width: 185px;
  font-size: 12px;
  text-align: center;
  height: 24px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin-top: 7px;
  margin-left: 8px;
}
.dateselect mat-form-field mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.dateselect mat-form-field mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.dateselect mat-form-field ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.dateselect mat-form-field mat-label {
  font-size: 12px;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle {
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle button {
  margin-left: 35px;
  width: 20px !important;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

::ng-deep .mat-mdc-form-field-icon-suffix,
[dir=rtl] .mat-mdc-form-field-icon-prefix {
  width: 30px !important;
  margin-top: 10px;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  align-items: center;
  border-radius: 5px;
}

::ng-deep .mat-mdc-icon-button {
  --mat-icon-button-hover-state-layer-opacity: 0 !important;
}

::ng-deep .mat-mdc-icon-button .mat-mdc-button-persistent-ripple {
  display: none;
}

.tab-header ::ng-deep .mat-mdc-tab-list {
  align-content: center;
}
.tab-header ::ng-deep .mat-mdc-tab-links {
  gap: 5px;
}

/** Date Picker **/
::ng-deep mat-datepicker-toggle {
  width: 0 !important;
}
::ng-deep mat-datepicker-toggle button {
  position: absolute;
  /* margin-bottom: -20px; */
  top: -23% !important;
  right: 40px;
}

.date-picker {
  height: 25px;
  min-width: 180px;
  font-size: 12px;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin: 7px 0;
}
.date-picker mat-form-field {
  width: 210px;
}
.date-picker ::ng-deep .mdc-text-field {
  padding-left: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  padding: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex {
  height: 23px;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {
  width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}
.date-picker mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-inner {
  letter-spacing: 0.5px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-container {
  justify-content: center;
  font-family: "Poppins";
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 10px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-end-wrapper {
  flex-grow: initial !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-wrapper {
  width: 70px;
}
.date-picker mat-label {
  font-size: 12px;
}
.date-picker ::ng-deep mat-datepicker-toggle button {
  width: 24px !important;
  height: 24px !important;
  padding: 0 !important;
  transform: translateX(10px);
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
  background-position: center;
}
.date-picker ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

/** Date Picker **/
.back-button,
.close-button {
  width: 35px;
  height: 35px;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: all 0.25s;
}

.back-button {
  background-image: url('back.svg');
}
.back-button:hover {
  background-image: url('back-hover.svg');
}

.close-button {
  background-image: url('close-circle.svg');
}
.close-button:hover {
  background-image: url('close-cirlce-hover.svg');
}

/* Global variables adn mixins are defined here */
::ng-deep .cdk-global-scrollblock {
  overflow: hidden;
}

::ng-deep mat-pseudo-checkbox {
  width: 0px !important;
}

::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  width: auto !important;
}

::ng-deep .mdc-list-item__primary-text {
  margin: 0px !important;
}

::ng-deep .mdc-tab__ripple {
  display: none;
}

::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled ~ .mdc-checkbox__background {
  background-color: #3e97ff !important;
  border-color: #3e97ff !important;
}

.toaster {
  background-color: #f4f7ff !important;
}

/* variables */
/* MIXINS */
/* mixin for border radius */
/* To create a section at the center of window */
/* To include and adjust background image */
/* to split the input */
/* box-shadow generator
    \$clr- in RGBA format
 */
/*
remove the autofilled background color
*/
/* mixin for create buttons */
/* generate margin & padding */
/* to set the table row */
/* to set the image */
/* to set the styles for first and last child div */
/* to set the font style */
.ast-table .table {
  margin-bottom: 0px;
}
.ast-table table thead th {
  background-color: #edeced;
  border: 1px solid #dee2e6;
  border-top: none !important;
}
.ast-table table td {
  background-color: #fafafa;
  color: #231f20;
  border: 0.5px solid #e2e2e1;
  font-size: 16px;
  font-weight: 500;
  font-family: "Amazon Ember Display Light";
}

/* To create a card at the center */
::ng-deep mat-pseudo-checkbox {
  display: none !important;
}

::ng-deep .mat-calendar-body-selected {
  background-color: #3e97ff !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {
  border-bottom: none !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before {
  border-bottom: none !important;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  background-color: #f2f4ff !important;
}

::ng-deep .mat-form-field {
  border: none !important;
}

.dateselect mat-form-field {
  display: flex;
  height: 25px;
  width: 185px;
  font-size: 12px;
  text-align: center;
  height: 24px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin-top: 7px;
  margin-left: 8px;
}
.dateselect mat-form-field mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.dateselect mat-form-field mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.dateselect mat-form-field ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.dateselect mat-form-field mat-label {
  font-size: 12px;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle {
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle button {
  margin-left: 35px;
  width: 20px !important;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

::ng-deep .mat-mdc-form-field-icon-suffix,
[dir=rtl] .mat-mdc-form-field-icon-prefix {
  width: 30px !important;
  margin-top: 10px;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  align-items: center;
  border-radius: 5px;
}

::ng-deep .mat-mdc-icon-button {
  --mat-icon-button-hover-state-layer-opacity: 0 !important;
}

::ng-deep .mat-mdc-icon-button .mat-mdc-button-persistent-ripple {
  display: none;
}

.tab-header ::ng-deep .mat-mdc-tab-list {
  align-content: center;
}
.tab-header ::ng-deep .mat-mdc-tab-links {
  gap: 5px;
}

/** Date Picker **/
::ng-deep mat-datepicker-toggle {
  width: 0 !important;
}
::ng-deep mat-datepicker-toggle button {
  position: absolute;
  /* margin-bottom: -20px; */
  top: -23% !important;
  right: 40px;
}

.date-picker {
  height: 25px;
  min-width: 180px;
  font-size: 12px;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin: 7px 0;
}
.date-picker mat-form-field {
  width: 210px;
}
.date-picker ::ng-deep .mdc-text-field {
  padding-left: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  padding: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex {
  height: 23px;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {
  width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}
.date-picker mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-inner {
  letter-spacing: 0.5px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-container {
  justify-content: center;
  font-family: "Poppins";
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 10px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-end-wrapper {
  flex-grow: initial !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-wrapper {
  width: 70px;
}
.date-picker mat-label {
  font-size: 12px;
}
.date-picker ::ng-deep mat-datepicker-toggle button {
  width: 24px !important;
  height: 24px !important;
  padding: 0 !important;
  transform: translateX(10px);
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
  background-position: center;
}
.date-picker ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

/** Date Picker **/
.back-button,
.close-button {
  width: 35px;
  height: 35px;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: all 0.25s;
}

.back-button {
  background-image: url('back.svg');
}
.back-button:hover {
  background-image: url('back-hover.svg');
}

.close-button {
  background-image: url('close-circle.svg');
}
.close-button:hover {
  background-image: url('close-cirlce-hover.svg');
}

.buttonClass {
  display: flex;
  align-items: center;
  padding: 0px;
  justify-content: flex-end;
}

.wrapper {
  background-color: #ffffff;
  margin-bottom: 50px;
  padding-bottom: 10px;
}

.form-group {
  margin: 20px;
}

input {
  border: none;
  background-color: #f2f4ff;
}

form {
  display: flex;
  width: 75%;
  justify-content: space-between;
}

label {
  float: left;
}

.form-actions {
  padding: 20px;
  width: 100%;
  text-align: right;
}
.form-actions .create-action {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 0;
  line-height: 15.5px;
  text-align: left;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 300;
  height: 31px;
  min-width: 100px;
  background: #3e97ff;
  color: #ffffff;
  position: relative;
  text-align: center;
  border: none !important;
  position: relative;
  overflow: hidden;
  transition: background 0.5s;
}
.form-actions .create-action:disabled {
  cursor: not-allowed;
}
.form-actions .create-action:focus {
  outline: none;
}
.form-actions .create-action:hover, .form-actions .create-action:focus, .form-actions .create-action:active {
  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
  text-decoration: none;
}
.form-actions .create-action:hover, .form-actions .create-action:focus, .form-actions .create-action:active {
  background: #3e97ff;
  color: #ffffff;
  border: 1px solid #3e97ff;
}
.form-actions .create-action span {
  position: relative;
  z-index: 10000;
  padding-left: 2px;
}
.form-actions .create-action img {
  margin-left: 7px;
  width: 12px;
}
.form-actions .hover-action::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #1e2238, #1e2238);
  transition: left 0.5s;
}
.form-actions .hover-action:hover::before {
  left: 0;
}
.form-actions .cancel-action {
  display: inline-block;
  margin-bottom: 0;
  line-height: 15.5px;
  text-align: left;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 300;
  height: 31px;
  min-width: 100px;
  background: #e1e3ea;
  color: #959cbd;
  position: relative;
  text-align: center;
  margin-right: 10px;
  border: none !important;
  position: relative;
  overflow: hidden;
  transition: background 0.5s;
}
.form-actions .cancel-action:disabled {
  cursor: not-allowed;
}
.form-actions .cancel-action:focus {
  outline: none;
}
.form-actions .cancel-action:hover, .form-actions .cancel-action:focus, .form-actions .cancel-action:active {
  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
  text-decoration: none;
}
.form-actions .cancel-action:hover, .form-actions .cancel-action:focus, .form-actions .cancel-action:active {
  background: #e1e3ea;
  color: #959cbd;
  border: 1px solid #e1e3ea;
}
.form-actions .cancel-action span {
  position: relative;
  z-index: 10000;
  padding-left: 2px;
}

.cancel-action::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #1e2238, #1e2238);
  transition: left 0.5s;
}

.cancel-action:hover::before {
  left: 0;
}

@media screen and (max-width: 767px) {
  .example-form {
    display: grid;
    gap: 20px;
    margin-bottom: 20px;
    width: 100%;
  }
  .wrapper {
    margin-bottom: 75px;
  }
}
@media (max-width: 300px) {
  .buttonClass {
    margin-left: 20px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .example-form {
    gap: 20px;
  }
}
.editor {
  padding: 20px;
}

form {
  display: block;
  width: 50%;
}

.create-action {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 0;
  line-height: 15.5px;
  text-align: left;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 300;
  height: 31px;
  min-width: 100px;
  background: #3e97ff;
  color: #ffffff;
  position: relative;
  text-align: center;
  border: none !important;
  position: relative;
  overflow: hidden;
  transition: background 0.5s;
}
.create-action:disabled {
  cursor: not-allowed;
}
.create-action:focus {
  outline: none;
}
.create-action:hover, .create-action:focus, .create-action:active {
  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
  text-decoration: none;
}
.create-action:hover, .create-action:focus, .create-action:active {
  background: #3e97ff;
  color: #ffffff;
  border: 1px solid #3e97ff;
}
.create-action span {
  color: #ffffff;
  position: relative;
  z-index: 9;
  padding-left: 2px;
}

.create-action::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #1e2238, #1e2238);
  transition: left 0.5s;
}

.create-action:hover::before {
  left: 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/global.scss","webpack://./src/app/bas/privacy-settings/prepare-privacy/prepare-privacy.component.scss","webpack://./src/app/bas/privacy-settings/change-logs/prepare-logs/prepare-logs.component.scss"],"names":[],"mappings":"AAAA,iDAAA;AAEA;EACE,gBAAA;ACAF;;ADGA;EACE,qBAAA;ACAF;;ADGA;EACE,sBAAA;ACAF;;ADQA;EACE,sBAAA;ACLF;;ADQA;EACE,aAAA;ACLF;;ADQA;;;EAGE,oCAAA;EACA,gCAAA;ACLF;;ADQA;EACE,oCAAA;ACLF;;ADQA,cAAA;AAmDA,WAAA;AAEA,4BAAA;AAcA,gDAAA;AAuBA,2CAAA;AAaA,uBAAA;AAgBA;;EAAA;AAUA;;CAAA;AAcA,6BAAA;AAoEA,8BAAA;AASA,yBAAA;AAuBA,qBAAA;AAQA,mDAAA;AAaA,0BAAA;AAmBE;EACE,kBAAA;AC9QJ;ADsRM;EACE,yBAAA;EACA,yBAAA;EACA,2BAAA;ACpRR;ADwRI;EAtEF,yBAwE2B;EAvE3B,cAuEoC;EAtEpC,2BAsE6C;EArE7C,eAqEkE;EAnElE,gBAAA;EACA,yCAAA;AChNF;;ADuRA,mCAAA;AA8BA;EACE,wBAAA;ACjTF;;ADoTA;EACE,oCAAA;ACjTF;;ADoTA;EACE,8BAAA;ACjTF;;ADoTA;EACE,8BAAA;ACjTF;;ADoTA;EACE,oCAAA;ACjTF;;ADoTA;EACE,uBAAA;ACjTF;;ADqTE;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AClTJ;ADoTI;EAKE,yBAAA;EACA,aAAA;EACA,oBAAA;ACtTN;ADgTM;EACE,yBAAA;AC9SR;ADsTI;EACE,8BAAA;ACpTN;ADuTI;EACE,eAAA;ACrTN;ADwTI;EACE,0CAAA;EACA,4BAAA;ACtTN;ADwTM;EACE,iBAAA;EACA,sBAAA;ACtTR;ADyTM;EACE,wBAAA;ACvTR;;AD6TA;;EAEE,sBAAA;EACA,gBAAA;AC1TF;;AD6TA;EACE,mBAAA;EACA,kBAAA;AC1TF;;AD6TA;EACE,yDAAA;AC1TF;;AD6TA;EACE,aAAA;AC1TF;;AD8TE;EACE,qBAAA;AC3TJ;AD8TE;EACE,QAAA;AC5TJ;;ADiUA,kBAAA;AAEA;EACE,mBAAA;AC/TF;ADiUE;EACE,kBAAA;EACA,0BAAA;EACA,oBAAA;EACA,WAAA;AC/TJ;;ADmUA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;EACA,aAAA;AChUF;ADkUE;EACE,YAAA;AChUJ;ADmUE;EACE,0BAAA;ACjUJ;ADoUE;EACE,qBAAA;AClUJ;ADqUE;EACE,YAAA;ACnUJ;ADsUE;EACE,mBAAA;EACA,qBAAA;EACA,oBAAA;ACpUJ;ADuUE;EACE,yBAAA;EACA,aAAA;EACA,oBAAA;ACrUJ;ADuUI;EACE,yBAAA;ACrUN;ADyUI;EACE,qBAAA;ACvUN;AD0UI;EACE,uBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,cAAA;ACxUN;AD2UI;EACE,8BAAA;ACzUN;AD4UI;EACE,6BAAA;AC1UN;AD6UI;EACE,WAAA;AC3UN;AD+UE;EACE,eAAA;AC7UJ;ADiVI;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;EACA,0CAAA;EACA,4BAAA;EACA,2BAAA;AC/UN;ADkVI;EACE,wBAAA;AChVN;;ADqVA,kBAAA;AAGA;;EAEE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,qBAAA;ACpVF;;ADuVA;EACE,iCAAA;ACpVF;ADsVE;EACE,uCAAA;ACpVJ;;ADwVA;EACE,yCAAA;ACrVF;ADuVE;EACE,+CAAA;ACrVJ;;ADlQA,iDAAA;AAEA;EACE,gBAAA;ACoQF;;ADjQA;EACE,qBAAA;ACoQF;;ADjQA;EACE,sBAAA;ACoQF;;AD5PA;EACE,sBAAA;AC+PF;;AD5PA;EACE,aAAA;AC+PF;;AD5PA;;;EAGE,oCAAA;EACA,gCAAA;AC+PF;;AD5PA;EACE,oCAAA;AC+PF;;AD5PA,cAAA;AAmDA,WAAA;AAEA,4BAAA;AAcA,gDAAA;AAuBA,2CAAA;AAaA,uBAAA;AAgBA;;EAAA;AAUA;;CAAA;AAcA,6BAAA;AAoEA,8BAAA;AASA,yBAAA;AAuBA,qBAAA;AAQA,mDAAA;AAaA,0BAAA;AAmBE;EACE,kBAAA;ACVJ;ADkBM;EACE,yBAAA;EACA,yBAAA;EACA,2BAAA;AChBR;ADoBI;EAtEF,yBAwE2B;EAvE3B,cAuEoC;EAtEpC,2BAsE6C;EArE7C,eAqEkE;EAnElE,gBAAA;EACA,yCAAA;ACoDF;;ADmBA,mCAAA;AA8BA;EACE,wBAAA;AC7CF;;ADgDA;EACE,oCAAA;AC7CF;;ADgDA;EACE,8BAAA;AC7CF;;ADgDA;EACE,8BAAA;AC7CF;;ADgDA;EACE,oCAAA;AC7CF;;ADgDA;EACE,uBAAA;AC7CF;;ADiDE;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AC9CJ;ADgDI;EAKE,yBAAA;EACA,aAAA;EACA,oBAAA;AClDN;AD4CM;EACE,yBAAA;AC1CR;ADkDI;EACE,8BAAA;AChDN;ADmDI;EACE,eAAA;ACjDN;ADoDI;EACE,0CAAA;EACA,4BAAA;AClDN;ADoDM;EACE,iBAAA;EACA,sBAAA;AClDR;ADqDM;EACE,wBAAA;ACnDR;;ADyDA;;EAEE,sBAAA;EACA,gBAAA;ACtDF;;ADyDA;EACE,mBAAA;EACA,kBAAA;ACtDF;;ADyDA;EACE,yDAAA;ACtDF;;ADyDA;EACE,aAAA;ACtDF;;AD0DE;EACE,qBAAA;ACvDJ;AD0DE;EACE,QAAA;ACxDJ;;AD6DA,kBAAA;AAEA;EACE,mBAAA;AC3DF;AD6DE;EACE,kBAAA;EACA,0BAAA;EACA,oBAAA;EACA,WAAA;AC3DJ;;AD+DA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;EACA,aAAA;AC5DF;AD8DE;EACE,YAAA;AC5DJ;AD+DE;EACE,0BAAA;AC7DJ;ADgEE;EACE,qBAAA;AC9DJ;ADiEE;EACE,YAAA;AC/DJ;ADkEE;EACE,mBAAA;EACA,qBAAA;EACA,oBAAA;AChEJ;ADmEE;EACE,yBAAA;EACA,aAAA;EACA,oBAAA;ACjEJ;ADmEI;EACE,yBAAA;ACjEN;ADqEI;EACE,qBAAA;ACnEN;ADsEI;EACE,uBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,cAAA;ACpEN;ADuEI;EACE,8BAAA;ACrEN;ADwEI;EACE,6BAAA;ACtEN;ADyEI;EACE,WAAA;ACvEN;AD2EE;EACE,eAAA;ACzEJ;AD6EI;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;EACA,0CAAA;EACA,4BAAA;EACA,2BAAA;AC3EN;AD8EI;EACE,wBAAA;AC5EN;;ADiFA,kBAAA;AAGA;;EAEE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,qBAAA;AChFF;;ADmFA;EACE,iCAAA;AChFF;ADkFE;EACE,uCAAA;AChFJ;;ADoFA;EACE,yCAAA;ACjFF;ADmFE;EACE,+CAAA;ACjFJ;;ACpgBA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;ADugBF;;ACpgBA;EACE,yBFmEM;EElEN,mBAAA;EACA,oBAAA;ADugBF;;ACpgBA;EACE,YAAA;ADugBF;;ACpgBA;EACE,YAAA;EACA,yBFqBc;ACkfhB;;ACpgBA;EACE,aAAA;EACA,UAAA;EACA,8BAAA;ADugBF;;ACpgBA;EACE,WAAA;ADugBF;;ACpgBA;EACE,aAAA;EACA,WAAA;EACA,iBAAA;ADugBF;ACrgBE;EACE,kCF0CW;EEzCX,gBF8CU;EAyGZ,qBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,0BAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EACA,6BAAA;EAzGA,kBEnDI;EF8JJ,eEhKI;EFiKJ,gBEhKI;EFiKJ,YEnKI;EFoKJ,gBErKI;EFsKJ,mBA7KQ;EA8KR,cAzIM;EA0IN,kBAAA;EACA,kBAAA;EElKE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;ADqhBJ;ADpXE;EACE,mBAAA;ACsXJ;ADnXE;EACE,aAAA;ACqXJ;ADlXE;EAME,yBAAA;EACA,uCAAA;EACA,qBAAA;AC+WJ;ADzWE;EAGE,mBA3MM;EA4MN,cAvKI;EAwKJ,yBAAA;ACyWJ;ACniBI;EAEE,kBAAA;EACA,cAAA;EACA,iBAAA;ADoiBN;ACjiBI;EACE,gBAAA;EACA,WAAA;ADmiBN;AC/hBE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,uDAAA;EACA,qBAAA;ADiiBJ;AC9hBE;EACE,OAAA;ADgiBJ;AC7hBE;EFyGA,qBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,0BAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EACA,6BAAA;EAzGA,kBENI;EFiHJ,eEnHI;EFoHJ,gBEnHI;EFoHJ,YEtHI;EFuHJ,gBExHI;EFyHJ,mBAzJS;EA0JT,cAxJS;EAyJT,kBAAA;EACA,kBAAA;EErHE,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;AD8iBJ;AD3bE;EACE,mBAAA;AC6bJ;AD1bE;EACE,aAAA;AC4bJ;ADzbE;EAME,yBAAA;EACA,uCAAA;EACA,qBAAA;ACsbJ;ADhbE;EAGE,mBAvLO;EAwLP,cAtLO;EAuLP,yBAAA;ACgbJ;AC5jBI;EAEE,kBAAA;EACA,cAAA;EACA,iBAAA;AD6jBN;;ACxjBA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,uDAAA;EACA,qBAAA;AD2jBF;;ACxjBA;EACE,OAAA;AD2jBF;;ACxjBA;EACE;IACE,aAAA;IACA,SAAA;IACA,mBAAA;IACA,WAAA;ED2jBF;ECxjBA;IACE,mBAAA;ED0jBF;AACF;ACvjBA;EACE;IACE,iBAAA;EDyjBF;AACF;ACtjBA;EACE;IACE,SAAA;EDwjBF;AACF;AA5sBA;EACE,aAAA;AA8sBF;;AA3sBA;EACE,cAAA;EACA,UAAA;AA8sBF;;AA3sBA;EACE,kCDqEa;ECpEb,gBDyEY;EAyGZ,qBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,0BAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EACA,6BAAA;EAzGA,kBC/EE;ED0LF,eC5LE;ED6LF,gBC5LE;ED6LF,YC/LE;EDgMF,gBCjME;EDkMF,mBA7KQ;EA8KR,cAzIM;EA0IN,kBAAA;EACA,kBAAA;EC/LA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;AA8tBF;ADhiBE;EACE,mBAAA;ACkiBJ;AD/hBE;EACE,aAAA;ACiiBJ;AD9hBE;EAME,yBAAA;EACA,uCAAA;EACA,qBAAA;AC2hBJ;ADrhBE;EAGE,mBA3MM;EA4MN,cAvKI;EAwKJ,yBAAA;ACqhBJ;AA5uBE;EACE,cD8CI;EC7CJ,kBAAA;EACA,UAAA;EACA,iBAAA;AA8uBJ;;AA1uBA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,uDAAA;EACA,qBAAA;AA6uBF;;AA1uBA;EACE,OAAA;AA6uBF","sourcesContent":["/* Global variables adn mixins are defined here */\n\n::ng-deep .cdk-global-scrollblock {\n  overflow: hidden;\n}\n\n::ng-deep mat-pseudo-checkbox {\n  width: 0px !important;\n}\n\n::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n  width: auto !important;\n  // height: auto !important;\n}\n\n// ::ng-deep mat-option{\n//     display: flex !important;\n//     justify-content: center !important;\n// }\n::ng-deep .mdc-list-item__primary-text {\n  margin: 0px !important;\n}\n\n::ng-deep .mdc-tab__ripple {\n  display: none;\n}\n\n::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,\n.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,\n.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=\"true\"]:enabled~.mdc-checkbox__background {\n  background-color: #3e97ff !important;\n  border-color: #3e97ff !important;\n}\n\n.toaster {\n  background-color: #f4f7ff !important;\n}\n\n/* variables */\n\n$primary: #3e97ff;\n$primary-active: #2884ef;\n$primary-light: #f2f4ff;\n$success: #50cd89;\n$success-active: #50cd89;\n$success-light: #e8fff3;\n$danger: #ff4b55;\n$danger-active: #d9214e;\n$danger-light: #fff5f8;\n$info: #7dcfdb;\n$info-active: #4fc9da;\n$info-light: #edf9fb;\n$warning: #ffa800;\n$warning-active: #ffa800;\n$warning-light: #fff7e7;\n$white: #ffffff;\n$white-active: #f5f8fa;\n$dark: #181c32;\n$gray-100: #f9f9f9;\n$gray-200: #f1f1f2;\n$gray-300: #e1e3ea;\n$gray-400: #d8d8e5;\n$gray-500: #959cbd;\n$gray-600: #7e8299;\n$gray-700: #5e6278;\n$gray-800: #3f4254;\n$gray-900: #181c32;\n$gray-button: #1e2238;\n\n//\n$primary-clr-dark: #232f3e;\n$primary-clr: #3e97ff;\n$primary-clr-alpha: #00a8e1;\n$bg-clr: #f3f3f3;\n$bg-clr-alpha: #edeced;\n$primary-ft-clr: #595a5c;\n$primary-grey: #707070;\n$white: #ffffff;\n$black: #3f4254;\n// $success: #347439;\n$failure: #ff0000;\n$grey: #cccccc;\n$primary-font: \"Poppins\", sans-serif;\n$ft-thin: 300;\n$ft-regular: 400;\n$ft-500: 500;\n$ft-bold: 700;\n$ft-semibold: 600;\n\n/* MIXINS */\n\n/* mixin for border radius */\n\n@mixin border-radius($top, $right, $bottom, $left) {\n  -webkit-border-radius: $top $right $bottom $left;\n  -moz-border-radius: $top $right $bottom $left;\n  border-radius: $top $right $bottom $left;\n}\n\n@mixin border-single-radius($rad) {\n  -webkit-border-radius: $rad;\n  -moz-border-radius: $rad;\n  border-radius: $rad;\n}\n\n/* To create a section at the center of window */\n@mixin create-centered-section($width,\n  $border-radius,\n  $padding-tb,\n  $padding-lr,\n  $border,\n  $background,\n  $left) {\n  position: absolute;\n  margin: auto;\n  top: 0;\n  left: $left;\n  right: 0;\n  bottom: 0;\n  width: $width;\n  height: 50vh;\n  // max-height: 520px;\n  border-radius: $border-radius;\n  padding: $padding-tb $padding-lr;\n  border: $border;\n  background: $background;\n}\n\n/* To include and adjust background image */\n@mixin set-background-image($bg-color,\n  $bg-url,\n  $bg-position,\n  $bg-repeat,\n  $bg-size) {\n  background: $bg-color;\n  background-image: $bg-url;\n  background-position: $bg-position;\n  background-repeat: $bg-repeat;\n  background-size: $bg-size;\n}\n\n/* to split the input */\n@mixin split-input($ltr-space,\n  $bg-img,\n  $bg-position,\n  $bg-size,\n  $bg-repeat,\n  $bg-pos-x) {\n  border: 0;\n  letter-spacing: $ltr-space;\n  background-image: $bg-img;\n  background-position: bottom;\n  background-size: $bg-size;\n  background-repeat: $bg-repeat;\n  background-position-x: $bg-pos-x;\n}\n\n/* box-shadow generator\n    $clr- in RGBA format\n */\n\n@mixin box-shadows($hset, $vset, $blur, $spread, $clr) {\n  -webkit-box-shadow: $hset $vset $blur $spread $clr;\n  -moz-box-shadow: $hset $vset $blur $spread $clr;\n  box-shadow: $hset $vset $blur $spread $clr;\n}\n\n/*\nremove the autofilled background color\n*/\n@mixin remove-autofill-background() {\n\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  input:-webkit-autofill:active {\n    transition-delay: 99999s;\n    -webkit-transition-delay: 99999s;\n  }\n}\n\n/* mixin for create buttons */\n\n@mixin create-buttons($bgClr,\n  $clr,\n  $ptb,\n  $plr,\n  $width,\n  $height,\n  $ft-size,\n  $ft-weight,\n  $rad) {\n  display: inline-block;\n  // padding: $ptb $plr;\n  margin-bottom: 0;\n  line-height: calc($height/2);\n  text-align: left;\n  white-space: nowrap;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  @include border-single-radius($rad);\n  font-size: $ft-size;\n  font-weight: $ft-weight;\n  height: $height;\n  min-width: $width;\n  background: $bgClr;\n  color: $clr;\n  position: relative;\n  text-align: center;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &:hover,\n  &:focus,\n  &:active {\n    // background: $clr;\n    // color: $bgClr;\n    // border: 1px solid $bgClr;\n    transition-duration: 0.5s;\n    transition-timing-function: ease-in-out;\n    text-decoration: none;\n  }\n}\n\n@mixin no-transition($bg-color, $color) {\n\n  &:hover,\n  &:focus,\n  &:active {\n    background: $bg-color;\n    color: $color;\n    border: 1px solid $bg-color;\n  }\n}\n\n/* generate margin & padding */\n@mixin generate-margin($tp, $rt, $bt, $lt) {\n  margin: $tp $rt $bt $lt;\n}\n\n@mixin generate-padding($tp, $rt, $bt, $lt) {\n  padding: $tp $rt $bt $lt;\n}\n\n/* to set the table row */\n@mixin set-table-row($bg-color,\n  $color,\n  $border,\n  $font-size,\n  $font-weight,\n  $fontFamily: \"\"\n\n) {\n  background-color: $bg-color;\n  color: $color;\n  border: $border;\n  font-size: $font-size;\n  // font-weight: $font-weight;\n  font-weight: 500;\n  font-family: \"Amazon Ember Display Light\";\n\n  @if $fontFamily !=\"\" {\n    font-family: $fontFamily;\n    font-weight: $font-weight;\n  }\n}\n\n/* to set the image */\n@mixin set-image-config($width, $height, $cursor, $margin-right) {\n  width: $width;\n  height: $height;\n  cursor: $cursor;\n  margin-right: $margin-right;\n}\n\n/* to set the styles for first and last child div */\n@mixin set-child-div($color1, $font-size1, $font-weight1, $color2) {\n  div:first-child {\n    color: $color1;\n    font-size: $font-size1;\n    font-weight: $font-weight1;\n  }\n\n  div:last-child {\n    color: $color2;\n  }\n}\n\n/* to set the font style */\n@mixin set-font-config($fontSize,\n  $fontWeight,\n  $fontColor,\n  $textAlign,\n  $fontFamily: \"\"\n\n) {\n  font-size: $fontSize;\n  font-weight: $fontWeight;\n  color: $fontColor;\n  text-align: $textAlign;\n\n  @if $fontFamily !=\"\" {\n    font-family: $fontFamily;\n  }\n}\n\n.ast-table {\n  .table {\n    margin-bottom: 0px;\n  }\n\n  table {\n    thead {\n\n      // @mixin set-table-row($bg-color, $color, $border, $font-size, $font-weight)\n      // @include set-table-row($white, #231f20, 0.5px solid #e2e2e1, 16px, 300) ;\n      th {\n        background-color: #edeced;\n        border: 1px solid #dee2e6;\n        border-top: none !important;\n      }\n    }\n\n    td {\n      // @mixin set-table-row($bg-color, $color, $border, $font-size, $font-weight)\n      @include set-table-row(#fafafa, #231f20, 0.5px solid #e2e2e1, 16px, 300);\n    }\n  }\n}\n\n/* To create a card at the center */\n@mixin create-card($width,\n  $height,\n  $border-radius,\n  $padding-tb,\n  $padding-lr,\n  $border,\n  $background,\n  $left) {\n  position: relative;\n  margin: auto;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: $width;\n  height: $height;\n  border-radius: $border-radius;\n  padding: $padding-tb $padding-lr;\n  border: $border;\n  background: $background;\n  text-align: center;\n}\n\n@mixin flexbox($display, $align-items, $justify-content) {\n  display: $display;\n  align-items: $align-items;\n  justify-content: $justify-content;\n}\n\n::ng-deep mat-pseudo-checkbox {\n  display: none !important;\n}\n\n::ng-deep .mat-calendar-body-selected {\n  background-color: $primary !important;\n}\n\n::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {\n  border-bottom: none !important;\n}\n\n::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before {\n  border-bottom: none !important;\n}\n\n::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {\n  background-color: $primary-light !important;\n}\n\n::ng-deep .mat-form-field {\n  border: none !important;\n}\n\n.dateselect {\n  mat-form-field {\n    display: flex;\n    height: 25px;\n    width: 185px;\n    font-size: 12px;\n    text-align: center;\n    height: 24px;\n    font-family: \"Poppins\", sans-serif;\n    font-weight: 500;\n    margin-top: 7px;\n    margin-left: 8px;\n\n    mat-date-range-input {\n      ::ng-deep .mat-date-range-input-separator {\n        color: #959cbd !important;\n      }\n\n      color: #959cbd !important;\n      display: flex;\n      justify-self: center;\n    }\n\n    ::ng-deep .mat-date-range-input-content {\n      border-bottom: none !important;\n    }\n\n    mat-label {\n      font-size: 12px;\n    }\n\n    ::ng-deep mat-datepicker-toggle {\n      background-image: url(../images/calendar-icon.svg);\n      background-repeat: no-repeat;\n\n      button {\n        margin-left: 35px;\n        width: 20px !important;\n      }\n\n      .mat-mdc-icon-button svg {\n        display: none !important;\n      }\n    }\n  }\n}\n\n::ng-deep .mat-mdc-form-field-icon-suffix,\n[dir=\"rtl\"] .mat-mdc-form-field-icon-prefix {\n  width: 30px !important;\n  margin-top: 10px;\n}\n\n::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {\n  align-items: center;\n  border-radius: 5px;\n}\n\n::ng-deep .mat-mdc-icon-button {\n  --mat-icon-button-hover-state-layer-opacity: 0 !important;\n}\n\n::ng-deep .mat-mdc-icon-button .mat-mdc-button-persistent-ripple {\n  display: none;\n}\n\n.tab-header {\n  ::ng-deep .mat-mdc-tab-list {\n    align-content: center;\n  }\n\n  ::ng-deep .mat-mdc-tab-links {\n    gap: 5px;\n  }\n}\n\n\n/** Date Picker **/\n\n::ng-deep mat-datepicker-toggle {\n  width: 0 !important;\n\n  button {\n    position: absolute;\n    /* margin-bottom: -20px; */\n    top: -23% !important;\n    right: 40px;\n  }\n}\n\n.date-picker {\n  height: 25px;\n  min-width: 180px;\n  font-size: 12px;\n  text-align: center;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 500;\n  margin: 7px 0;\n\n  mat-form-field {\n    width: 210px;\n  }\n\n  ::ng-deep .mdc-text-field {\n    padding-left: 0 !important;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix {\n    padding: 0 !important;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex {\n    height: 23px;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {\n    width: 0 !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n\n  mat-date-range-input {\n    color: #959cbd !important;\n    display: flex;\n    justify-self: center;\n\n    ::ng-deep .mat-date-range-input-separator {\n      color: #959cbd !important;\n      // margin: 0 10px;\n    }\n\n    ::ng-deep .mat-date-range-input-inner {\n      letter-spacing: 0.5px;\n    }\n\n    ::ng-deep .mat-date-range-input-container {\n      justify-content: center;\n      font-family: \"Poppins\";\n      width: fit-content;\n      margin: 0 10px;\n    }\n\n    ::ng-deep .mat-date-range-input-content {\n      border-bottom: none !important;\n    }\n\n    ::ng-deep .mat-date-range-input-end-wrapper {\n      flex-grow: initial !important;\n    }\n\n    ::ng-deep .mat-date-range-input-wrapper {\n      width: 70px;\n    }\n  }\n\n  mat-label {\n    font-size: 12px;\n  }\n\n  ::ng-deep mat-datepicker-toggle {\n    button {\n      width: 24px !important;\n      height: 24px !important;\n      padding: 0 !important;\n      transform: translateX(10px);\n      background-image: url(../images/calendar-icon.svg);\n      background-repeat: no-repeat;\n      background-position: center;\n    }\n\n    .mat-mdc-icon-button svg {\n      display: none !important;\n    }\n  }\n}\n\n/** Date Picker **/\n\n\n.back-button,\n.close-button {\n  width: 35px;\n  height: 35px;\n  background-position: center;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  transition: all .25s;\n}\n\n.back-button {\n  background-image: url('../images/back.svg');\n\n  &:hover {\n    background-image: url('../images/back-hover.svg');\n  }\n}\n\n.close-button {\n  background-image: url('../images/close-circle.svg');\n\n  &:hover {\n    background-image: url('../images/close-cirlce-hover.svg');\n  }\n}","@import \"src/assets/styles/global.scss\";\n@import \"../change-logs/prepare-logs/prepare-logs.component.scss\";\n\n.editor {\n  padding: 20px;\n}\n\nform {\n  display: block;\n  width: 50%;\n}\n\n.create-action {\n  font-family: $primary-font;\n  font-weight: $ft-semibold;\n  @include create-buttons($primary,\n    $white,\n    0px,\n    0px,\n    100px,\n    31px,\n    13px,\n    300,\n    5px);\n  @include no-transition($primary, $white);\n  border: none !important;\n  position: relative;\n  overflow: hidden;\n  transition: background 0.5s;\n\n  span {\n    color: $white;\n    position: relative;\n    z-index: 9;\n    padding-left: 2px;\n  }\n}\n\n.create-action::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(to right, $gray-button, $gray-button);\n  transition: left 0.5s;\n}\n\n.create-action:hover::before {\n  left: 0;\n}","@import \"src/assets/styles/global.scss\";\n\n.buttonClass {\n  display: flex;\n  align-items: center;\n  padding: 0px;\n  justify-content: flex-end;\n}\n\n.wrapper {\n  background-color: $white;\n  margin-bottom: 50px;\n  padding-bottom: 10px;\n}\n\n.form-group {\n  margin: 20px;\n}\n\ninput {\n  border: none;\n  background-color: $primary-light;\n}\n\nform {\n  display: flex;\n  width: 75%;\n  justify-content: space-between;\n}\n\nlabel {\n  float: left;\n}\n\n.form-actions {\n  padding: 20px;\n  width: 100%;\n  text-align: right;\n\n  .create-action {\n    font-family: $primary-font;\n    font-weight: $ft-semibold;\n    // @mixin create-buttons($bgClr,$clr,$ptb,$plr,$width,$height,$ft-size,$ft-weight,$rad)\n    @include create-buttons($primary,\n      $white,\n      0px,\n      0px,\n      100px,\n      31px,\n      13px,\n      300,\n      5px);\n    // @mixin no-transition($bg-color, $color)\n    @include no-transition($primary, $white);\n    border: none !important;\n    position: relative;\n    overflow: hidden;\n    transition: background 0.5s;\n\n    span {\n      // color: $white;\n      position: relative;\n      z-index: 10000;\n      padding-left: 2px;\n    }\n\n    img {\n      margin-left: 7px;\n      width: 12px;\n    }\n  }\n\n  .hover-action::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(to right, $gray-button, $gray-button);\n    transition: left 0.5s;\n  }\n\n  .hover-action:hover::before {\n    left: 0;\n  }\n\n  .cancel-action {\n    @include create-buttons($gray-300,\n      $gray-500,\n      0px,\n      0px,\n      100px,\n      31px,\n      13px,\n      300,\n      5px);\n    // @mixin no-transition($bg-color, $color)\n    @include no-transition($gray-300, $gray-500);\n    margin-right: 10px;\n    border: none !important;\n    position: relative;\n    overflow: hidden;\n    transition: background 0.5s;\n\n    span {\n      // color: $white;\n      position: relative;\n      z-index: 10000;\n      padding-left: 2px;\n    }\n  }\n}\n\n.cancel-action::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(to right, $gray-button, $gray-button);\n  transition: left 0.5s;\n}\n\n.cancel-action:hover::before {\n  left: 0;\n}\n\n@media screen and (max-width: 767px) {\n  .example-form {\n    display: grid;\n    gap: 20px;\n    margin-bottom: 20px;\n    width: 100%;\n  }\n\n  .wrapper {\n    margin-bottom: 75px;\n  }\n}\n\n@media (max-width: 300px) {\n  .buttonClass {\n    margin-left: 20px;\n  }\n}\n\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .example-form {\n    gap: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
